import React, { useCallback, useMemo } from 'react';
import { ISelectOption, Select } from '../../ui-toolkit';
import { INewOrderSchema } from './validation/NewOrderSchema';
import { optionsFromDisplay } from '../../ui-toolkit/enums/optionsFromDisplay';
import { DisplayTransactionCategory, eTransactionCategory } from 'ui-toolkit/enums/eTransactionType';
import { ePartyPurpose } from '../../ui-toolkit/enums/ePartyPurpose';
import { useField, useFormikContext } from 'formik';

export const onTransactionTypeChange = (
  fieldName: string,
  values: INewOrderSchema,
  setFieldValue: (name: string, value: any) => void,
  setFieldTouched: (name: string, touched?: boolean) => void
) => {
  return (option: ISelectOption<eTransactionCategory> | null) => {
    if (!option) {
      setFieldValue(fieldName, undefined);
      setFieldTouched(fieldName, true);
      return;
    }
    const changeFrom = option.value !== eTransactionCategory.Purchase ? ePartyPurpose.buyer : ePartyPurpose.borrower;
    const changeTo = option.value === eTransactionCategory.Purchase ? ePartyPurpose.buyer : ePartyPurpose.borrower;
    if (!!values.parties) {
      values.parties.forEach((party, index) => {
        if (party.purpose === changeFrom) {
          setFieldValue(`parties.${index}.purpose`, changeTo);
        }
      });
    }
    setFieldValue(fieldName, option.value);
    setFieldTouched(fieldName, true);
  };
};

export const TransactionCategorySelect: React.FC<{ autoFocus: boolean }> = ({ autoFocus }) => {
  const transformValueToSelect = useCallback(
    (options: ISelectOption<string>[]) => (value: string) => options.find((t) => t.value === value),
    []
  );
  const transactionTypeOptions = useMemo(() => optionsFromDisplay(DisplayTransactionCategory), []);
  const [field] = useField({ name: 'transactionCategory' });
  const formik = useFormikContext<INewOrderSchema>();
  const value = transformValueToSelect(transactionTypeOptions)(field.value);
  const onChange = onTransactionTypeChange(
    'transactionCategory',
    formik.values,
    formik.setFieldValue,
    formik.setFieldTouched
  );

  return (
    <Select
      {...field}
      data-test-id={'transactionCategory'}
      value={value}
      options={transactionTypeOptions}
      label={`Transaction Type`}
      autoFocus={autoFocus}
      onChange={onChange}
    />
  );
};
